import i18n from "@/shared/config/i18n";
import HomeView from "@/pages/home/HomeView.vue";
import ConstructorActionList from "@/pages/admin/ConstructorActions/ConstructorActionList.vue";
import ConstructorActionsItem from "@/pages/admin/ConstructorActions/ConstructorActionsItem.vue";
import { DefaultLayout } from "@/widgets/app-layout";
import EmptyRouterView from "@/pages/EmptyRouterView.vue";

// Users
import UsersIndex from "@/pages/admin/users/UsersIndex.vue";
import UserList from "@/pages/admin/users/UserList.vue";
import UserItem from "@/pages/admin/users/UserItem.vue";
import NotariesList from "@/pages/admin/users/NotariesList.vue";

// Roles
import RoleList from "@/pages/admin/roles/RoleList.vue";
import RoleItem from "@/pages/admin/roles/RoleItem.vue";

// Organizations
import OrganizationList from "@/pages/admin/organizations/OrganizationList.vue";
import OrganizationItem from "@/pages/admin/organizations/OrganizationItem.vue";

// Reference
// import ReferenceList from "@/pages/admin/references/ReferenceList.vue";
// import ReferenceItem from "@/pages/admin/references/ReferenceItem.vue";

// Reference2
import DirectoryList from "@/pages/admin/references2/DirectoryList.vue";
import DirectoryItem2 from "@/pages/admin/references2/DirectoryItem.vue";

// Notarial Act Templates
import NotarialTransactionList from "@/pages/admin/notarial_transactions/NotarialTransactionList.vue";

// Hereditary Cases
import HereditaryCaseList from "@/pages/admin/hereditary_cases/HereditaryCaseList.vue";
import HereditaryCaseItem from "@/pages/admin/hereditary_cases/HereditaryCaseItem.vue";
import ExecutiveInscriptionList from "@/pages/admin/executive_inscriptions/ExecutiveInscriptionList.vue";
import ExecutiveInscriptionItem from "@/pages/admin/executive_inscriptions/ExecutiveInscriptionItem.vue";
import NotarialActionItem from "@/pages/admin/home/notarial_actions/NotarialActionsItem.vue";
import ClientCabinetList from "@/pages/admin/client_cabinet/ClientCabinetList.vue";
import ClientCabinetItem from "@/pages/admin/client_cabinet/ClientCabinetItem.vue";
import ClientAiChat from "@/pages/admin/client_cabinet/ClientAiChat.vue";

// AI Assistant
import AiAssistantPage from "@/pages/admin/ai_assistant/AiAssistantPage.vue";

// Statistics
import StatisticsList from "@/pages/admin/statistics/StatisticsList.vue";

// Logging
import LoggingList from "@/pages/admin/logging/LoggingList.vue";
import LoggingItem from "@/pages/admin/logging/LoggingItem.vue";

// Face ID + Devices
import SettingsIndex from "@/pages/admin/settings/SettingsIndex.vue";
import FaceIdTab from "@/pages/admin/settings/tabs/FaceIdTab.vue";
import DevicesTab from "@/pages/admin/settings/tabs/DevicesTab.vue";

//Tariffs
import TariffList from "@/pages/admin/tariffs/tariff/TariffList.vue";
import TariffItem from "@/pages/admin/tariffs/tariff/TariffItem.vue";

//Benefits
import BenefitList from "@/pages/admin/tariffs/benefits/BenefitList.vue";
import BenefitItem from "@/pages/admin/tariffs/benefits/BenefitItem.vue";

//Mrp
import MrpList from "@/pages/admin/tariffs/mrp/MrpList.vue";
import MrpItem from "@/pages/admin/tariffs/mrp/MrpItem.vue";

const defaultRoutes = [
  {
    path: "/",
    name: "default",
    role: "default",
    component: DefaultLayout,
    meta: {
      sourceRoot: true,
      isMain: true,
      title: i18n.global.t("Главная страница"),
    },

    redirect: { name: "default_home_dashboard" },
    children: [
      {
        path: "home",
        name: "default_home_dashboard",
        component: EmptyRouterView,
        meta: {
          title: i18n.global.t("Главная страница"),
          icon: "sli-main",
          isDashboardItem: true,
          permissionsAny: ["TVNT", "IVND"],
          group: "Меню",
        },

        redirect: { name: "home_dashboard" },
        children: [
          {
            path: "dashboard",
            name: "home_dashboard",
            component: HomeView,
            meta: {
              title: i18n.global.t("Панель управления"),
              isNavbarItem: true,
            },
          },
          {
            path: "notarial_action_new",
            name: "notarial_action_new",
            component: NotarialActionItem,
            meta: {
              title: i18n.global.t("Создание действия"),
              isNavbarItem: true,
              isDashboardItem: true,
            },
          },
          {
            path: ":id",
            name: "notarial_action_edit",
            component: NotarialActionItem,
            meta: {
              title: i18n.global.t("Редактирование действия"),
              isNavbarItem: true,
              isDashboardItem: true,
            },
          },
          {
            path: "view/:id",
            name: "notarial_action_view",
            component: NotarialActionItem,
            meta: {
              title: i18n.global.t("Просмотр действия"),
              isNavbarItem: true,
              isDashboardItem: true,
            },
          },
        ],
      },
      {
        path: "notarial-act-templates",
        name: "notarial-act-templates",
        component: EmptyRouterView,
        meta: {
          title: i18n.global.t("Реестр действий"),
          icon: "huge-list-check",
          isDashboardItem: true,
          permissions: ["TVNT"],
          group: "Меню",
        },
        redirect: { name: "notarial_list" },
        children: [
          {
            path: "list",
            name: "notarial_list",
            component: NotarialTransactionList,
            meta: {
              title: i18n.global.t("Реестр действий"),
              isNavbarItem: true,
              permissions: ["TVNT"],
            },
          },
        ],
      },
      {
        path: "hereditary-cases",
        name: "hereditary-cases",
        component: EmptyRouterView,
        meta: {
          title: i18n.global.t("Наследственные дела"),
          icon: "huge-inheritance",
          isDashboardItem: true,
          permissions: ["IVND"],
          group: "Меню",
        },
        redirect: { name: "hereditary_case_list" },
        children: [
          {
            path: "list",
            name: "hereditary_case_list",
            component: HereditaryCaseList,
            meta: {
              title: i18n.global.t("Реестр наследственных дел"),
              isNavbarItem: true,
              permissions: ["IVND"],
            },
          },
          {
            path: "new",
            name: "hereditary_case_new",
            component: HereditaryCaseItem,
            meta: {
              title: i18n.global.t("Создание действия"),
              isNavbarItem: true,
              isDashboardItem: true,
              permissions: ["ICND"],
            },
          },
          {
            path: ":id",
            name: "hereditary_case_edit",
            component: HereditaryCaseItem,
            meta: {
              title: i18n.global.t("Редактирование действия"),
              isNavbarItem: true,
              isDashboardItem: true,
              permissions: ["IUND"],
            },
          },
          {
            path: "view/:id",
            name: "hereditary_case_view",
            component: HereditaryCaseItem,
            meta: {
              title: i18n.global.t("Просмотр действия"),
              isNavbarItem: true,
              isDashboardItem: true,
              permissions: ["IVND"],
            },
          },
        ],
      },
      {
        path: "executive-inscriptions",
        name: "executive-inscriptions",
        component: EmptyRouterView,
        meta: {
          title: i18n.global.t("Исполнительные надписи"),
          icon: "huge-inscription",
          isDashboardItem: true,
          permissions: ["TVNT"],
          group: "Меню",
        },
        redirect: { name: "exec_inscription_list" },
        children: [
          {
            path: "list",
            name: "exec_inscription_list",
            component: ExecutiveInscriptionList,
            meta: {
              title: i18n.global.t("Реестр исполнительных надписей"),
              isNavbarItem: true,
              permissions: ["TVNT"],
            },
          },
          {
            path: "new",
            name: "exec_inscription_new",
            component: ExecutiveInscriptionItem,
            meta: {
              title: i18n.global.t("Создание исполнительной надписи"),
              isNavbarItem: true,
              isDashboardItem: true,
              permissions: ["TCNT"],
            },
          },
          {
            path: ":id",
            name: "exec_inscription_edit",
            component: ExecutiveInscriptionItem,
            meta: {
              title: i18n.global.t("Редактирование исполнительной надписи"),
              isNavbarItem: true,
              isDashboardItem: true,
              permissions: ["UDNT"],
            },
          },
          {
            path: "view/:id",
            name: "exec_inscription_view",
            component: ExecutiveInscriptionItem,
            meta: {
              title: i18n.global.t("Просмотр исполнительной надписи"),
              isNavbarItem: true,
              isDashboardItem: true,
              permissions: ["TVNT"],
            },
          },
        ],
      },

      {
        path: "client",
        name: "client",
        component: EmptyRouterView,
        meta: {
          title: i18n.global.t("Мои заявки"),
          icon: "huge-list-check",
          isDashboardItem: true,
          permissions: ["CVCAAD"], //hide
          group: "Кабинет клиента",
        },
        redirect: { name: "client_dashboard" },
        children: [
          {
            path: "dashboard",
            name: "client_dashboard",
            component: ClientCabinetList,
            meta: {
              title: i18n.global.t("Просмотр"),
              isNavbarItem: true,
              isDashboardItem: true,
              permissions: ["CVCA"],
            },
          },
          {
            path: "document/:id",
            name: "client_document_view",
            component: ClientCabinetItem,
            meta: {
              title: i18n.global.t("Документ"),
              isNavbarItem: true,
              isDashboardItem: true,
            },
          },
          {
            path: "ai-chat",
            name: "client_ai_chat",
            component: ClientAiChat,
            meta: {
              title: i18n.global.t("AI-помощник"),
              isNavbarItem: true,
              isDashboardItem: true,
            },
          },
        ],
      },

      {
        path: "ai-assistant",
        name: "ai-assistant",
        component: EmptyRouterView,
        meta: {
          title: i18n.global.t("AI-нотариус"),
          icon: "huge-ai",
          isDashboardItem: true,
          roles: ["ADMIN", "NOTARY"],
          group: "Teamspace",
        },
        redirect: { name: "ai_assistant_page" },
        children: [
          {
            path: "chat",
            name: "ai_assistant_page",
            component: AiAssistantPage,
            meta: {
              title: i18n.global.t("AI Нотариус"),
              isNavbarItem: true,
            },
          },
        ],
      },
      {
        path: "meet",
        name: "meet",
        component: EmptyRouterView,
        meta: {
          icon: "sli-camera",
          title: i18n.global.t("Meet"),
          isDashboardItem: true,
          withoutPadding: true,
          roles: ["ADMIN", "NOTARY"],
          group: "Teamspace",
        },
        redirect: { name: "meet_page" },
        children: [
          {
            path: "",
            name: "meet_page",
            component: () => import("@/pages/Meet/MeetsIndex.vue"),
            meta: {
              title: i18n.global.t("Meet"),
              isNavbarItem: true,
            },
          },
        ],
      },
      {
        path: "calendar",
        name: "calendar_events",
        component: EmptyRouterView,
        meta: {
          icon: "sli-calendar",
          title: i18n.global.t("Календарь"),
          isDashboardItem: true,
          withoutPadding: true,
          roles: ["ADMIN", "NOTARY"],
          group: "Teamspace",
        },
        redirect: { name: "calendar_page" },
        children: [
          {
            path: "",
            name: "calendar_page",
            component: () =>
              import("@/pages/Calendar/GeneralCalendarIndex.vue"),
            meta: {
              title: i18n.global.t("Календарь"),
              isNavbarItem: true,
            },
          },
        ],
      },
      {
        path: "todo",
        name: "todo",
        component: EmptyRouterView,
        meta: {
          title: i18n.global.t("To-Do"),
          icon: "sli-clipboard",
          isDashboardItem: true,
          withoutPadding: true,
          roles: ["ADMIN", "NOTARY"],
          group: "Teamspace",
        },
        redirect: { name: "todo_page" },
        children: [
          {
            path: "",
            name: "todo_page",
            component: () =>
              import(
                /* webpackChunkName: "TodoIndex" */ "@/pages/Todo/index.vue"
              ),
            meta: {
              title: i18n.global.t("To-Do"),
              isNavbarItem: true,
            },
          },
        ],
      },
      {
        path: "rmo",
        name: "rmo",
        component: EmptyRouterView,
        meta: {
          icon: "sli-calls",
          title: i18n.global.t("РМО"),
          isDashboardItem: true,
          withoutPadding: true,
          roles: ["ADMIN", "NOTARY"],
          group: "Меню",
        },
        redirect: { name: "rmo_page" },
        children: [
          {
            path: "",
            name: "rmo_page",
            component: () => import("@/pages/admin/qbox/RmoIndex.vue"),
            meta: {
              title: i18n.global.t("РМО"),
              isNavbarItem: true,
            },
          },
        ],
      },
      {
        path: "constructor",
        name: "constructor",
        component: EmptyRouterView,
        meta: {
          title: i18n.global.t("Конструктор действий"),
          icon: "huge-puzzle",
          isDashboardItem: true,
          permissions: ["TVT"],
          group: "Меню",
        },
        redirect: { name: "constructor_action_list" },
        children: [
          {
            path: "list",
            name: "constructor_action_list",
            component: ConstructorActionList,
            meta: {
              title: i18n.global.t("Список действий"),
              isNavbarItem: true,
            },
          },
          {
            path: ":id",
            name: "constructor_action_new",
            component: ConstructorActionsItem,
            meta: {
              title: i18n.global.t("Создание действия"),
              isNavbarItem: true,
              isDashboardItem: true,
            },
          },
          {
            path: ":id",
            name: "constructor_action_item",
            component: ConstructorActionsItem,
            meta: {
              title: i18n.global.t("Редактирование действия"),
              isNavbarItem: true,
              isDashboardItem: true,
            },
          },
          {
            path: "view/:id",
            name: "constructor_action_item_view",
            component: ConstructorActionsItem,
            meta: {
              title: i18n.global.t("Просмотр действия"),
              isNavbarItem: true,
              isDashboardItem: true,
            },
          },
        ],
      },
      {
        path: "tariffs-chapter",
        name: "tariffs-chapter",
        component: EmptyRouterView,
        meta: {
          title: i18n.global.t("Тарифы"),
          icon: "huge-tariff",
          isDashboardItem: true,
          permissionsAny: ["TVD", "MVD"],
          group: "Меню",
        },
        redirect: { name: "tariff_list" },
        children: [
          {
            path: "tariffs",
            name: "tariffs",
            component: EmptyRouterView,
            meta: {
              title: i18n.global.t("Тарифы для НД"),
              icon: "huge-tariff",
              isDashboardItem: true,
            },
            redirect: { name: "tariff_list" },
            children: [
              {
                path: "list",
                name: "tariff_list",
                component: TariffList,
                meta: {
                  isDashboardItem: true,
                  permissions: ["TVD"],
                },
              },
              {
                path: "new",
                name: "tariff_new",
                component: TariffItem,
                meta: {
                  title: i18n.global.t("Создание тарифа"),
                  isNavbarItem: true,
                  isDashboardItem: true,
                  permissions: ["TCD"],
                },
              },
              {
                path: ":id",
                name: "tariff_item",
                component: TariffItem,
                meta: {
                  title: i18n.global.t("Редактирование тарифа"),
                  isNavbarItem: true,
                  isDashboardItem: true,
                  permissions: ["TUD"],
                },
              },
              {
                path: "view/:id",
                name: "tariff_item_view",
                component: TariffItem,
                meta: {
                  title: i18n.global.t("Просмотр тарифа"),
                  isNavbarItem: true,
                  isDashboardItem: true,
                  permissions: ["TVD"],
                },
              },
            ],
          },

          // Льготы
          {
            path: "benefits",
            name: "benefits",
            component: EmptyRouterView,
            redirect: { name: "benefit_list" },
            meta: {
              title: i18n.global.t("Льготы"),
              icon: "huge-tariff",
              isDashboardItem: true,
              permissions: ["TVD"],
            },
            children: [
              {
                path: "list",
                name: "benefit_list",
                component: BenefitList,
                meta: {
                  title: i18n.global.t("Льготы"),
                  isDashboardItem: true,
                  permissions: ["TVD"],
                },
              },
              {
                path: "new",
                name: "benefit_new",
                component: BenefitItem,
                meta: {
                  title: i18n.global.t("Создание льготы"),
                  isDashboardItem: true,
                  permissions: ["TCD"],
                },
              },
              {
                path: ":id",
                name: "benefit_item",
                component: BenefitItem,
                meta: {
                  title: i18n.global.t("Редактирование льготы"),
                  isDashboardItem: true,
                  permissions: ["TUD"],
                },
              },
              {
                path: "view/:id",
                name: "benefit_item_view",
                component: BenefitItem,
                meta: {
                  title: i18n.global.t("Просмотр льготы"),
                  isDashboardItem: true,
                  permissions: ["TVD"],
                },
              },
            ],
          },

          // Мрп
          {
            path: "mrp",
            name: "mrp",
            component: EmptyRouterView,
            redirect: { name: "mrp_list" },
            meta: {
              title: i18n.global.t("МРП"),
              icon: "huge-tariff",
              isDashboardItem: true,
              permissions: ["MVD"],
            },
            children: [
              {
                path: "list",
                name: "mrp_list",
                component: MrpList,
                meta: {
                  isDashboardItem: true,
                  permissions: ["MVD"],
                },
              },
              {
                path: "new",
                name: "mrp_new",
                component: MrpItem,
                meta: {
                  isDashboardItem: true,
                  title: i18n.global.t("Создание МРП"),
                  permissions: ["MCD"],
                },
              },
              {
                path: ":id",
                name: "mrp_item",
                component: MrpItem,
                meta: {
                  isDashboardItem: true,
                  title: i18n.global.t("Редактирование МРП"),
                  permissions: ["MUD"],
                },
              },
              {
                path: "view/:id",
                name: "mrp_item_view",
                component: MrpItem,
                meta: {
                  isDashboardItem: true,
                  title: i18n.global.t("Просмотр МРП"),
                  permissions: ["MVD"],
                },
              },
            ],
          },
        ],
      },

      {
        path: "invoices",
        name: "admin_invoices",
        component: () => import("@/pages/admin/invoices/InvoicesList.vue"),
        meta: {
          title: i18n.global.t("Инвойсы"),
          icon: "huge-document-info",
          isDashboardItem: true,
          permissionsAny: ["TVDDD"], // hide
          group: "Меню",
        },
      },

      {
        path: "organizations",
        name: "organizations",
        component: EmptyRouterView,
        meta: {
          title: i18n.global.t("Организации"),
          permissions: ["AVO"],
          icon: "huge-organization",
          isDashboardItem: true,
          group: "Меню",
        },
        redirect: { name: "organization_list" },
        children: [
          {
            path: "list",
            name: "organization_list",
            component: OrganizationList,
            meta: {
              title: i18n.global.t("Организации"),
              isNavbarItem: true,
              permissions: ["AVO"],
            },
          },
          {
            path: "new",
            name: "organization_new",
            component: OrganizationItem,
            meta: {
              title: i18n.global.t("Создание организации"),
              isNavbarItem: true,
              isDashboardItem: true,
              permissions: ["ACO"],
            },
            props: () => ({
              selectedUser: null,
            }),
          },
          {
            path: ":id",
            name: "organization_item",
            component: OrganizationItem,
            meta: {
              title: i18n.global.t("Редактирование организации"),
              isNavbarItem: true,
              isDashboardItem: true,
              permissions: ["AUO"],
            },
          },
          {
            path: "view/:id",
            name: "organization_item_view",
            component: OrganizationItem,
            meta: {
              title: i18n.global.t("Просмотр организации"),
              isNavbarItem: true,
              isDashboardItem: true,
              permissions: ["AVO"],
            },
          },
        ],
      },
      {
        path: "users",
        name: "users",
        component: UsersIndex,
        meta: {
          title: i18n.global.t("Пользователи"),
          icon: "sli-legacy",
          isDashboardItem: true,
          permissions: ["AVU"],
          group: "Меню",
        },
        redirect: { name: "user_list" },
        children: [
          {
            path: "list",
            name: "user_list",
            component: UserList,
            meta: {
              title: i18n.global.t("Пользователи"),
              isNavbarItem: true,
              isSidebarChild: true,
              permissions: ["AVU"],
            },
          },
          {
            path: "new",
            name: "user_new",
            component: UserItem,
            meta: {
              title: i18n.global.t("Создание пользователя"),
              isNavbarItem: true,
              isDashboardItem: true,
              permissions: ["ACU"],
            },
            props: true,
          },
          {
            path: "notaries",
            name: "notary_list",
            component: NotariesList,
            meta: {
              title: i18n.global.t("Нотариусы"),
              isNavbarItem: true,
              isSidebarChild: true,
              permissions: ["AVU"],
            },
          },
          {
            path: ":id",
            name: "user_item",
            component: UserItem,
            meta: {
              title: i18n.global.t("Редактирование пользователя"),
              isNavbarItem: true,
              isDashboardItem: true,
              permissions: ["AUU"],
            },
            props: true,
          },
          {
            path: "view/:id",
            name: "user_item_view",
            component: UserItem,
            meta: {
              title: i18n.global.t("Просмотр пользователя"),
              isNavbarItem: true,
              isDashboardItem: true,
              permissions: ["AVU"],
            },
            props: true,
          },
        ],
      },
      {
        path: "roles",
        name: "roles",
        component: EmptyRouterView,
        meta: {
          title: i18n.global.t("Роли"),
          icon: "huge-clients",
          isDashboardItem: true,
          permissions: ["AVR"],
          group: "Меню",
        },
        redirect: { name: "role_list" },
        children: [
          {
            path: "list",
            name: "role_list",
            component: RoleList,
            meta: {
              title: i18n.global.t("Роли"),
              isNavbarItem: true,
              permissions: ["AVR"],
            },
          },
          {
            path: "new",
            name: "role_new",
            component: RoleItem,
            meta: {
              title: i18n.global.t("Создание роли"),
              isNavbarItem: true,
              isDashboardItem: true,
              permissions: ["ACR"],
            },
          },
          {
            path: ":id",
            name: "role_item",
            component: RoleItem,
            meta: {
              title: i18n.global.t("Редактирование роли"),
              isNavbarItem: true,
              isDashboardItem: true,
              permissions: ["AUR"],
            },
          },
          {
            path: "view/:id",
            name: "role_item_view",
            component: RoleItem,
            meta: {
              title: i18n.global.t("Просмотр роли"),
              isNavbarItem: true,
              isDashboardItem: true,
              permissions: ["AVR"],
            },
          },
        ],
      },
      // {
      //   path: "references",
      //   name: "references",
      //   component: EmptyRouterView,
      //   meta: {
      //     title: i18n.global.t("Справочники"),
      //     icon: "huge-directory",
      //     isDashboardItem: true,
      //     permissions: ["DVD"],
      //   },
      //   redirect: { name: "reference_list" },
      //   children: [
      //     {
      //       path: "list",
      //       name: "reference_list",
      //       component: ReferenceList,
      //       meta: {
      //         title: i18n.global.t("Справочники"),
      //         isNavbarItem: true,
      //         permissions: ["DVD"],
      //       },
      //     },
      //     {
      //       path: "new",
      //       name: "reference_new",
      //       component: ReferenceItem,
      //       meta: {
      //         title: i18n.global.t("Создание справочника"),
      //         isNavbarItem: true,
      //         isDashboardItem: true,
      //         permissions: ["DCD"],
      //       },
      //       props: true,
      //     },
      //     {
      //       path: ":id",
      //       name: "reference_item",
      //       component: ReferenceItem,
      //       meta: {
      //         title: i18n.global.t("Редактирование справочника"),
      //         isNavbarItem: true,
      //         isDashboardItem: true,
      //         permissions: ["DUD"],
      //       },
      //       props: true,
      //     },
      //     {
      //       path: "view/:id",
      //       name: "reference_item_view",
      //       component: ReferenceItem,
      //       meta: {
      //         title: i18n.global.t("Просмотр справочника"),
      //         isNavbarItem: true,
      //         isDashboardItem: true,
      //         permissions: ["DVD"],
      //       },
      //       props: true,
      //     },
      //   ],
      // },
      {
        path: "references2",
        name: "references2",
        component: EmptyRouterView,
        meta: {
          title: i18n.global.t("Справочники"),
          icon: "huge-directory",
          isDashboardItem: true,
          permissions: ["DVD"],
          group: "Меню",
        },
        redirect: { name: "reference_list2" },
        children: [
          {
            path: "list",
            name: "reference_list2",
            component: DirectoryList,
            meta: {
              title: i18n.global.t("Справочники"),
              isNavbarItem: true,
              permissions: ["DVD"],
            },
          },
          {
            path: "new",
            name: "reference_new2",
            component: DirectoryItem2,
            meta: {
              title: i18n.global.t("Создание справочника"),
              isNavbarItem: true,
              isDashboardItem: true,
              permissions: ["DCD"],
            },
            props: true,
          },
          {
            path: ":id",
            name: "reference_item2",
            component: DirectoryItem2,
            meta: {
              title: i18n.global.t("Редактирование справочника"),
              isNavbarItem: true,
              isDashboardItem: true,
              permissions: ["DUD"],
            },
            props: true,
          },
          {
            path: "view/:id",
            name: "reference_item_view2",
            component: DirectoryItem2,
            meta: {
              title: i18n.global.t("Просмотр справочника"),
              isNavbarItem: true,
              isDashboardItem: true,
              permissions: ["DVD"],
            },
            props: true,
          },
        ],
      },
      {
        path: "statistics",
        name: "statistics",
        component: EmptyRouterView,
        meta: {
          title: i18n.global.t("Статистика"),
          icon: "sli-static",
          isDashboardItem: true,
          permissions: ["CVST"],
          group: "Меню",
        },
        redirect: { name: "statistics_list" },
        children: [
          {
            path: "list",
            name: "statistics_list",
            component: StatisticsList,
            meta: {
              title: i18n.global.t("Статистика"),
              isNavbarItem: true,
              permissions: ["CVST"],
            },
          },
        ],
      },
      {
        path: "logging",
        name: "logging",
        component: EmptyRouterView,
        meta: {
          title: i18n.global.t("Журнал логирования"),
          icon: "huge-journal",
          isDashboardItem: true,
          permissions: ["LEVL"],
          group: "Меню",
        },
        redirect: { name: "logging_list" },
        children: [
          {
            path: "list",
            name: "logging_list",
            component: LoggingList,
            meta: {
              title: i18n.global.t("Журнал логирования"),
              isNavbarItem: true,
              permissions: ["LEVL"],
            },
          },
          {
            path: ":id",
            name: "logging_item",
            component: LoggingItem,
            meta: {
              title: i18n.global.t("Редактирование действия"),
              isNavbarItem: true,
              isDashboardItem: true,
              permissions: ["LEVL"],
            },
          },
          {
            path: "view/:id",
            name: "logging_item_view",
            component: LoggingItem,
            meta: {
              title: i18n.global.t("Просмотр действия"),
              isNavbarItem: true,
              isDashboardItem: true,
              permissions: ["LEVL"],
            },
          },
        ],
      },
      {
        path: "face-id",
        name: "face_id",
        component: SettingsIndex,
        redirect: { name: "face_id_users" },
        meta: {
          title: "Face ID",
          icon: "sli-face-id",
          isDashboardItem: true,
          roles: ["ADMIN"],
          group: "Меню",
        },
        children: [
          {
            path: "users",
            name: "face_id_users",
            component: FaceIdTab,
            props: { view: "users" },
            meta: {
              roles: ["ADMIN"],
              title: i18n.global.t("Пользователи"),
              heading: "Face ID",
              subheading: "Биометрическая аутентификация сотрудников",
              isSidebarChild: true,
            },
          },
          {
            path: "attempts",
            name: "face_id_attempts",
            component: FaceIdTab,
            props: { view: "attempts" },
            meta: {
              roles: ["ADMIN"],
              title: i18n.global.t("История"),
              heading: "История",
              subheading: "Журнал попыток биометрической идентификации",
              isSidebarChild: true,
            },
          },
          {
            path: "devices",
            name: "face_id_devices",
            component: DevicesTab,
            meta: {
              roles: ["ADMIN"],
              permissions: ["AVU"],
              title: i18n.global.t("Устройства"),
              heading: "Устройства",
              subheading: "Управление устройствами пользователей",
              isSidebarChild: true,
            },
          },
        ],
      },
    ],
  },
  {
    path: "/viewing/transactions/:id",
    name: "public_transaction_view_auth",
    component: () => import("@/pages/public/PublicTransactionView.vue"),
    meta: {
      title: "Просмотр транзакции",
    },
  },
];

export default defaultRoutes;
